import * as React from 'react';
import { useKeycloak } from '@react-keycloak/web';
import { Navigate } from 'react-router-dom';
import useRedirectTo from '../../helpers/location';

const Logout: React.FC = () => {
  const currentLocationState = useRedirectTo();

  const { keycloak } = useKeycloak();

  if (keycloak?.authenticated) {
    keycloak?.logout({ redirectUri: window.location.origin });
  }

  return <Navigate to={currentLocationState.from.pathname} />;
};

export default Logout;
